export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8029.b1b9c9be.jpg";